import React from 'react';
import { Form } from 'react-bootstrap';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import type { LayerDef } from 'hooks/Meteorology/Agro/Maps/useAgroMapState';

import './index.scss';

export interface LayersSheetProps {
  open: boolean;
  dismiss: () => void;
  layers: Record<string, boolean>;
  onToggle: (key: string) => () => void;
  definitions: LayerDef[];
}

export default function LayersSheet({
  open,
  dismiss,
  layers,
  onToggle,
  definitions,
}: LayersSheetProps) {
  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Camadas"
      className="agro-ci-area-layers-sheet"
    >
      <div className="agro-ci-area-layers-list">
        {definitions.map(({ key, label }) => (
          <Form.Check
            key={key}
            type="switch"
            id={`agro-ci-area-layer-${key}`}
            label={label}
            className="agro-ci-area-layer-row"
            checked={layers[key] ?? true}
            onChange={onToggle(key)}
          />
        ))}
      </div>
    </BottomSheet>
  );
}
